import { useEffect, useState } from 'react';
import Card from './Card/Card';
import { Container, Button } from 'react-bootstrap';
import style from "./Cards.module.scss";
import { ConcertsDataProps } from '../../../../../interface/interface';
import { arrowDownIcon } from '../../../../../shared/svg/svgFiles';
import { ButtonText, UpcomingConcerts } from '../../../../../shared/enum/enum';
import { Timestamp } from 'firebase/firestore';
import { useConcerts } from '../../../../../customHooks/customHooks';
import SkeletonLoader from './SkeletonLoader/SkeletonLoader';

// Helper: get midnight today in Armenia timezone
const getYerevanToday = () => {
    const yerevanStr = new Date().toLocaleDateString("en-CA", {
        timeZone: "Asia/Yerevan"
    }); // e.g., "2025-05-23"
    return new Date(yerevanStr); // interpreted as midnight local time
};

// Helper: get midnight today in user's local timezone
const getLocalToday = () => {
    const now = new Date();
    now.setHours(0, 0, 0, 0);
    return now;
};



const Cards = () => {
    // Detect user's timezone
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    // Use Armenia midnight if user is in Armenia, else local midnight
    const now = userTimeZone === "Asia/Yerevan" ? getYerevanToday() : getLocalToday();

    const { data, getDataFromFirestore } = useConcerts();
    const [visibleCount, setVisibleCount] = useState(8);
    const [isLoading, setIsLoading] = useState(true);


console.log("User Timezone:", userTimeZone);
console.log("Now (used for filtering):", now.toString());

    useEffect(() => {
        getDataFromFirestore().then(() => setIsLoading(false));
    }, []);

    // Filter concerts based on now depending on user timezone
    const sortedConcerts = data
        .filter((concert) => {
            const concertDate = concert.date instanceof Timestamp ? concert.date.toDate() : new Date(concert.date);
            return concertDate.getTime() >= now.getTime();
        })
        .sort((a, b) => {
            const dateA = a.date instanceof Timestamp ? a.date.toDate() : new Date(a.date);
            const dateB = b.date instanceof Timestamp ? b.date.toDate() : new Date(b.date);
            return dateA.getTime() - dateB.getTime();
        });

    const visibleConcerts = sortedConcerts.slice(0, visibleCount);

    // Group concerts by month
    const concertsByMonth: Record<string, ConcertsDataProps[]> = {};
    visibleConcerts.forEach((concert) => {
        const concertDate = concert.date instanceof Timestamp ? concert.date.toDate() : new Date(concert.date);
        const monthKey = concertDate.toLocaleString('default', { month: 'long' });

        if (!concertsByMonth[monthKey]) {
            concertsByMonth[monthKey] = [];
        }
        concertsByMonth[monthKey].push(concert);
    });

    const handleViewMore = () => {
        setVisibleCount((prev) => prev + 8);
    };

    return (
        <Container className={style.cardsContainer}>

            {/* Info label about time zone based expiration */}
            <p style={{ fontSize: 12, color: "#666", marginBottom: 16, textAlign: "center" }}>
                {userTimeZone === "Asia/Yerevan"}
            </p>

            {isLoading ? (
                <SkeletonLoader />
            ) : sortedConcerts.length === 0 ? (
                <div className={style.noDataTextContainer}>
                    <p className={style.text1}>{UpcomingConcerts.NoData1}</p>
                    <p className={style.text2}>{UpcomingConcerts.NoData2}</p>
                    <p className={style.text3}>{UpcomingConcerts.NoData3}</p>
                </div>
            ) : (
                Object.entries(concertsByMonth).map(([month, concerts]) => (
                    <div key={month} className={style.cards}>
                        <h5>{month}</h5>
                        {concerts.length > 0 ? (
                            concerts.map((concert) => (
                                <Card key={concert.id} data={concert} />
                            ))
                        ) : (
                            <p>No concerts in {month}.</p>
                        )}
                    </div>
                ))
            )}

            {visibleCount < sortedConcerts.length && sortedConcerts.length > 0 && (
                <div className={style.buttonContainer}>
                    <Button className={style.viewMoreButton} onClick={handleViewMore}>
                        {ButtonText.ViewMore}{arrowDownIcon}
                    </Button>
                </div>
            )}
        </Container>
    );
};

export default Cards;
